import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ShrinkType } from "~/gql/graphqlBase.generated";

export interface ShrinkEntryState {
	dateIso: string;
	grade?: number;
	notes: string;
	producedLocationId?: string;
	quantity: number;
	selectedJobId?: string;
	shrinkType?: ShrinkType;
}

export interface ShrinkEntryDraftUpdate {
	dateIso?: string;
	grade?: number;
	notes?: string;
	producedLocationId?: string;
	quantity?: number;
	shrinkType?: ShrinkType;
}

const initialState: ShrinkEntryState = {
	dateIso: "",
	notes: "",
	quantity: 0
};

const clearEntryFields = (state: ShrinkEntryState) => {
	state.shrinkType = undefined;
	state.quantity = 0;
	state.notes = "";
};

export const shrinkEntrySlice = createSlice({
	initialState,
	name: "shrinkEntry",
	reducers: {
		clearShrinkEntry: () => initialState,
		resetEntryDraft: (state) => {
			clearEntryFields(state);
		},
		setSelectedJob: (state, action: PayloadAction<string | undefined>) => {
			state.selectedJobId = action.payload;
			state.grade = undefined;
			state.producedLocationId = undefined;
			clearEntryFields(state);
		},
		updateEntryDraft: (state, action: PayloadAction<ShrinkEntryDraftUpdate>) => {
			Object.assign(state, action.payload);
		}
	}
});

export const { clearShrinkEntry, resetEntryDraft, setSelectedJob, updateEntryDraft } = shrinkEntrySlice.actions;

export default shrinkEntrySlice.reducer;
